import React from 'react';
import classnames from 'classnames';

import { Section, Layout, SEO, VoucherRedeemSection, BrowseWebGamesSection } from '..';

import style from './RedeemPage.module.less';

import voucher from './assets/standardVoucher.png';
import allyOldDog from './assets/allyOldDog.png';

export const RedeemPage = () => (
  <Layout>
    <SEO
      title="Redeem vouchers"
      description="Received a gift voucher? Redeem it here and gain access to one of our games. It's that easy!"
      image={voucher}
    />

    <VoucherRedeemSection className={classnames(style.firstSection, style.redeemSection)} />

    <Section className={classnames(style.section)} alternate={true}>
      <div className={style.content}>
        <h1 className={style.header}>Learn more?</h1>

        <div className={classnames(style.row)}>
          <div className={style.text}>
            <p>If you have any questions please consult one of the following sections:</p>
            <ul>
              <li><a href="/games/cryptic-killer-unboxing">About a game: "Unboxing the mind of a Cryptic Killer"</a></li>
              <li><a href="/how-to-play">How to play</a></li>
              <li><a href="/faq">FAQ</a></li>
            </ul>
            <p>If the above resources didn't help, please don't hesitate to contact us!</p>
          </div>
          <div className={classnames(style.image)}>
            <img src={allyOldDog} alt="ally and old dog" />
          </div>
        </div>
      </div>
    </Section>

    <BrowseWebGamesSection />
  </Layout>
);
